<script>
    import asyncImage from './asyncImage';

    /**
     * This is a VueJS driven async, and optionally dynamic, image loader,
     *
     * An image load can be triggered via three methods
     * 1) Via an intersection observer detecting the image scrolling within the actively viewed DOM
     * 2) Via a page resize event
     * 3) If intersection is not available, it will be loaded on initialization
     */
    export default {
        name: 'VueImage',

        mixins: [asyncImage],
    };
</script>

<template>
    <img
        v-cloak
        :class="{
            'invisible': !wasLoaded
        }"
        :src="imageSource"
    >
</template>